"use strict";

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertIsArbitrary = exports.Arbitrary = void 0;

var Shrinkable_1 = require("./Shrinkable");

var Arbitrary = /*#__PURE__*/function () {
  function Arbitrary() {
    _classCallCheck(this, Arbitrary);
  }

  _createClass(Arbitrary, [{
    key: "filter",
    value: function filter(refinement) {
      return new FilterArbitrary(this, refinement);
    }
  }, {
    key: "map",
    value: function map(mapper) {
      return new MapArbitrary(this, mapper);
    }
  }, {
    key: "chain",
    value: function chain(fmapper) {
      return new ChainArbitrary(this, fmapper);
    }
  }, {
    key: "noShrink",
    value: function noShrink() {
      return new NoShrinkArbitrary(this);
    }
  }, {
    key: "withBias",
    value: function withBias(_freq) {
      return this;
    }
  }, {
    key: "noBias",
    value: function noBias() {
      return new NoBiasArbitrary(this);
    }
  }]);

  return Arbitrary;
}();

exports.Arbitrary = Arbitrary;

var ChainArbitrary = /*#__PURE__*/function (_Arbitrary) {
  _inherits(ChainArbitrary, _Arbitrary);

  var _super = _createSuper(ChainArbitrary);

  function ChainArbitrary(arb, fmapper) {
    var _this;

    _classCallCheck(this, ChainArbitrary);

    _this = _super.call(this);
    _this.arb = arb;
    _this.fmapper = fmapper;
    return _this;
  }

  _createClass(ChainArbitrary, [{
    key: "generate",
    value: function generate(mrng) {
      var clonedMrng = mrng.clone();
      var src = this.arb.generate(mrng);
      var dst = this.fmapper(src.value).generate(mrng);
      return ChainArbitrary.shrinkChain(clonedMrng, src, dst, this.fmapper);
    }
  }, {
    key: "withBias",
    value: function withBias(freq) {
      var _this2 = this;

      return this.arb.withBias(freq).chain(function (t) {
        return _this2.fmapper(t).withBias(freq);
      });
    }
  }], [{
    key: "shrinkChain",
    value: function shrinkChain(mrng, src, dst, fmapper) {
      return new Shrinkable_1.Shrinkable(dst.value, function () {
        return src.shrink().map(function (v) {
          return ChainArbitrary.shrinkChain(mrng.clone(), v, fmapper(v.value).generate(mrng.clone()), fmapper);
        }).join(dst.shrink());
      });
    }
  }]);

  return ChainArbitrary;
}(Arbitrary);

var MapArbitrary = /*#__PURE__*/function (_Arbitrary2) {
  _inherits(MapArbitrary, _Arbitrary2);

  var _super2 = _createSuper(MapArbitrary);

  function MapArbitrary(arb, mapper) {
    var _this3;

    _classCallCheck(this, MapArbitrary);

    _this3 = _super2.call(this);
    _this3.arb = arb;
    _this3.mapper = mapper;
    return _this3;
  }

  _createClass(MapArbitrary, [{
    key: "generate",
    value: function generate(mrng) {
      return this.arb.generate(mrng).map(this.mapper);
    }
  }, {
    key: "withBias",
    value: function withBias(freq) {
      return this.arb.withBias(freq).map(this.mapper);
    }
  }]);

  return MapArbitrary;
}(Arbitrary);

var FilterArbitrary = /*#__PURE__*/function (_Arbitrary3) {
  _inherits(FilterArbitrary, _Arbitrary3);

  var _super3 = _createSuper(FilterArbitrary);

  function FilterArbitrary(arb, refinement) {
    var _this4;

    _classCallCheck(this, FilterArbitrary);

    _this4 = _super3.call(this);
    _this4.arb = arb;
    _this4.refinement = refinement;
    return _this4;
  }

  _createClass(FilterArbitrary, [{
    key: "generate",
    value: function generate(mrng) {
      var g = this.arb.generate(mrng);

      while (!this.refinementOnShrinkable(g)) {
        g = this.arb.generate(mrng);
      }

      return g.filter(this.refinement);
    }
  }, {
    key: "withBias",
    value: function withBias(freq) {
      return this.arb.withBias(freq).filter(this.refinement);
    }
  }, {
    key: "refinementOnShrinkable",
    value: function refinementOnShrinkable(s) {
      return this.refinement(s.value);
    }
  }]);

  return FilterArbitrary;
}(Arbitrary);

var NoShrinkArbitrary = /*#__PURE__*/function (_Arbitrary4) {
  _inherits(NoShrinkArbitrary, _Arbitrary4);

  var _super4 = _createSuper(NoShrinkArbitrary);

  function NoShrinkArbitrary(arb) {
    var _this5;

    _classCallCheck(this, NoShrinkArbitrary);

    _this5 = _super4.call(this);
    _this5.arb = arb;
    return _this5;
  }

  _createClass(NoShrinkArbitrary, [{
    key: "generate",
    value: function generate(mrng) {
      return new Shrinkable_1.Shrinkable(this.arb.generate(mrng).value);
    }
  }, {
    key: "withBias",
    value: function withBias(freq) {
      return this.arb.withBias(freq).noShrink();
    }
  }]);

  return NoShrinkArbitrary;
}(Arbitrary);

var NoBiasArbitrary = /*#__PURE__*/function (_Arbitrary5) {
  _inherits(NoBiasArbitrary, _Arbitrary5);

  var _super5 = _createSuper(NoBiasArbitrary);

  function NoBiasArbitrary(arb) {
    var _this6;

    _classCallCheck(this, NoBiasArbitrary);

    _this6 = _super5.call(this);
    _this6.arb = arb;
    return _this6;
  }

  _createClass(NoBiasArbitrary, [{
    key: "generate",
    value: function generate(mrng) {
      return this.arb.generate(mrng);
    }
  }]);

  return NoBiasArbitrary;
}(Arbitrary);

function assertIsArbitrary(instance) {
  if (typeof instance !== 'object' || instance === null || !('generate' in instance)) {
    throw new Error('Unexpected value received: not an instance of Arbitrary');
  }
}

exports.assertIsArbitrary = assertIsArbitrary;